import Link from 'next/link';
import { ResultMenuType } from '@components/acca/results/result/resultTab';
import { VersionType } from '@domain/constant/acca/VersionType';
import { RouteUrl } from '@utils/routeUtil';

import classNames from 'classnames/bind';
import styles from './applyResultSample.module.scss';

const cx = classNames.bind(styles);

interface ApplyResultSampleProps {
  isPst?: boolean;
  version?: VersionType | null;
  resultMenu?: ResultMenuType;
}

const ApplyResultSample = ({ isPst, version, resultMenu }: ApplyResultSampleProps) => {
  const isResultMenu = (menu: ResultMenuType) => resultMenu === menu;
  const getTitleText = () => {
    if (version === 'V3' && isResultMenu('APPLY')) return '응시 점검 결과를 확인할 수 있어요.';
    if (version === 'V3' && isResultMenu('COMPETENCY')) return '기본 분석 결과를 확인할 수 있어요.';
    return '응시 분석 결과를 볼 수 있어요.';
  };

  return (
    <div
      className={cx(
        'resultSampleArea',
        { pst: !!isPst },
        { v3: version === 'V3' },
        { APPLY: isResultMenu('APPLY') },
        { COMPETENCY: isResultMenu('COMPETENCY') },
      )}
    >
      <strong className={cx('title')}>
        프로필을 입력하면
        <br />
        {getTitleText()}
      </strong>

      <p className={cx('desc')}>
        <Link href={RouteUrl.PROFILE} legacyBehavior>
          <a className={cx('link')} target="_blank" role="button">
            [내 프로필]
          </a>
        </Link>
        에서 기본, 선호, 학력만 입력하면 끝!
        <br />
        <Link href={RouteUrl.MATCH_APPLY} legacyBehavior>
          <a className={cx('link')} target="_blank" role="button">
            매칭 제안 받기
          </a>
        </Link>{' '}
        상태가 ON이어야 합니다.
      </p>

      <Link href={RouteUrl.PROFILE} legacyBehavior>
        <a className={cx('btn')} target="_blank" role="button">
          1분만에 프로필 입력하기
        </a>
      </Link>
    </div>
  );
};

export default ApplyResultSample;
